import * as React from 'react';
import { actionCreators } from '../../store/User/UserStore';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UserMessaging from './UserMessaging.js';

class UserProfile extends React.Component {

    componentWillMount() {
        this.props.getUserProfile();
    }

    componentDidUpdate() {
        if (this.props.reload === true) {
            this.props.getUserProfile();
        }
    }

    onResendVerificationCode() {
        this.props.resendVerificationCode();
    }
    onMobileUpdate(number) {
        this.props.setMobileNumber(number);
    }

    onMobileVerify(code) {
        this.props.verifyMobile(code);
    }

    onCancel() {
        this.props.getUserProfile(true);
    }

    render() {
        return ( 
            <div>
                <h1 className='mt-2'>Profile</h1>
                <input id="swebPopup" name="swebPopup" type="hidden" />
                <UserMessaging
                    email={this.props.email}
                    mobile={this.props.mobile}
                    edit={false || this.props.codeSent}
                    validationMessage={this.props.validationMessage}
                    codeSent={this.props.codeSent}
                    verified={this.props.mobileVerified}
                    canEdit={this.props.canEdit}
                    countries={this.props.countries}
                    showWarning={this.props.showWarning}
                    onMobileUpdate={(number) => this.onMobileUpdate(number)}
                    onMobileVerify={(code) => this.onMobileVerify(code)}
                    onResendVerificationCode={() => this.onResendVerificationCode()}
                    onCancel={() => this.onCancel()}/>
            </div>
        );
    }
}

export default connect(
    state => state.userStore,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(UserProfile);


// WEBPACK FOOTER //
// ./src/components/User/UserProfile.js